import CasChangesTable, { IChangesTabProps } from '../CasChangesTable/CasChangesTable';
// utils
import { getLRPFormInfo } from './getLRPFormInfo';

const TYPE_OPTIONS = [
  { name: 'Account', id: 'Account' },
  { name: 'Accelerated', id: 'Accelerated' },
  { name: 'Schedule', id: 'Schedule' },
  { name: 'Addit Compensation', id: 'Addit Compensation' },
  { name: 'Agency', id: 'Agency' },
  { name: 'Source', id: 'Source' },
];

export default function LRPChangesTab(props: IChangesTabProps) {
  return (
    <CasChangesTable
      entity="Ins/CommissionChanges"
      typeOptions={TYPE_OPTIONS}
      getEditRowInfo={getLRPFormInfo}
      {...props}
    />
  );
}
